<p-card class="p-card container" [class.proposal-section--valid]="isCompleted && form.valid">
  @if (isDev && !isCompleted && !isReadonly) {
    <p-button label="Simulate" class="btn--simulate" (onClick)="simulateClient()"></p-button>
  }

  <h3 i18n>Informations du client</h3>

  <form [formGroup]="form">
    <div class="layout__inner-card">
      <div class="layout--gap margin--bottom-medium">
        <div class="layout--full-width">
          <label class="label-top" for="firstName" i18n>Prénom</label>
          <input
            [ngClass]="{
              'error--input': form.controls.firstName.invalid && form.controls.firstName.touched,
            }"
            i18n-placeholder
            placeholder="Prénom"
            [formControl]="form.controls.firstName"
            id="firstName"
            type="text"
            [maxLength]="25"
            pInputText />
          @if (form.controls.firstName.hasError('maxlength')) {
            <p class="error margin--top-smaller" i18n>Maximum de 25 caractères</p>
          }
          @if (form.controls.firstName.hasError('noSpecialCharacterInvalid')) {
            <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
          }
          @if (form.controls.firstName.hasError('noNumberInvalid')) {
            <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="middleName" i18n>Deuxième prénom (optionnel)</label>
          <input
            [ngClass]="{
              'error--input': form.controls.middleName.invalid && form.controls.middleName.touched,
            }"
            i18n-placeholder
            placeholder="Deuxième prénom"
            [formControl]="form.controls.middleName"
            id="middleName"
            type="text"
            [maxLength]="25"
            pInputText />
          @if (form.controls.middleName.hasError('maxlength')) {
            <p class="error margin--top-smaller" i18n>Maximum de 25 caractères</p>
          }
          @if (form.controls.middleName.hasError('noSpecialCharacterInvalid')) {
            <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
          }
          @if (form.controls.middleName.hasError('noNumberInvalid')) {
            <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="lastName" i18n>Nom de famille</label>
          <input
            [ngClass]="{
              'error--input': form.controls.lastName.invalid && form.controls.lastName.touched,
            }"
            i18n-placeholder
            placeholder="Nom de famille"
            [formControl]="form.controls.lastName"
            id="lastName"
            type="text"
            [maxLength]="25"
            pInputText />
          @if (form.controls.lastName.hasError('maxlength')) {
            <p class="error margin--top-smaller" i18n>Maximum de 25 caractères</p>
          }
          @if (form.controls.lastName.hasError('noSpecialCharacterInvalid')) {
            <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
          }
          @if (form.controls.lastName.hasError('noNumberInvalid')) {
            <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="birthday" i18n>Date de naissance</label>
          <div class="layout--row layout--gap">
            <input
              [ngClass]="{
                'error--input': form.controls.birthday.invalid && form.controls.birthday.touched,
              }"
              i18n-placeholder
              placeholder="JJ/MM/AAAA"
              [formControl]="form.controls.birthday"
              id="birthday"
              mask="d0/M0/0000"
              [dropSpecialCharacters]="false"
              pInputText />
            <em-text-indicator
              [text]="age?.toString()"
              [withTooltip]="isProposalSubmitted"
              i18n-tooltipText
              tooltipText="Âge du client au moment de l'achat."></em-text-indicator>
          </div>
          @if (
            !form.controls.birthday.hasError('dateInvalid') &&
            form.controls.birthday.hasError('atLeast18YearsOldInvalid')
          ) {
            <p class="error margin--top-smaller" i18n> Doit être âgé de 18 ans et plus</p>
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="sex" i18n>Sexe</label>
          <p-dropdown
            [options]="sexOptions | emTranslate"
            [styleClass]="form.controls.sex.invalid && form.controls.sex.touched ? 'error--input' : ''"
            i18n-placeholder
            placeholder="Choisir"
            [formControl]="form.controls.sex"
            id="sex"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>
      </div>

      <div class="layout--gap">
        <div class="layout--full-width">
          <label class="label-top" for="province" i18n>Province</label>
          <p-dropdown
            [options]="supportedProvincesOptions | emTranslate"
            [filter]="true"
            [virtualScroll]="true"
            [virtualScrollItemSize]="20"
            filterBy="name"
            filterMatchMode="startsWith"
            [formControl]="form.controls.province"
            optionLabel="name"
            optionValue="value"
            i18n-placeholder
            placeholder="Choisir"
            i18n-emptyFilterMessage
            emptyFilterMessage="Aucun résultat"></p-dropdown>
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="preferredLanguage" i18n>Langue</label>
          <p-dropdown
            [options]="languageOptions | emTranslate"
            [styleClass]="
              form.controls.preferredLanguage.invalid && form.controls.preferredLanguage.touched
                ? 'error--input'
                : ''
            "
            i18n-placeholder
            placeholder="Choisir"
            [formControl]="form.controls.preferredLanguage"
            id="preferredLanguage"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="email" i18n>Adresse courriel</label>
          <input
            [ngClass]="{
              'error--input': form.controls.email.invalid && form.controls.email.touched,
            }"
            i18n-placeholder
            placeholder="Adresse courriel"
            [formControl]="form.controls.email"
            id="email"
            type="text"
            pInputText />
          @if (form.controls.email.hasError('fakeVisitorEmailInvalid')) {
            <p class="error margin--top-smaller" i18n> Courriel invalide</p>
          }
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="phone" i18n>Numéro de téléphone</label>
          <input
            [ngClass]="{
              'error--input': form.controls.phone.invalid && form.controls.phone.touched,
            }"
            [formControl]="form.controls.phone"
            (paste)="onPhonePaste($event)"
            i18n-placeholder
            placeholder="Numéro de téléphone"
            id="phone"
            type="tel"
            mask="(000) 000-0000"
            pInputText />
        </div>
      </div>
    </div>
  </form>
</p-card>

@if (displayCreateButton) {
  <p-button
    [disabled]="form.invalid"
    [loading]="isButtonLoading"
    (onClick)="createProposal()"
    class="flex justify-content-end margin--top-medium"
    i18n-label
    label="Créer la proposition"
    icon="pi pi-check"></p-button>
}
